module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_013.png
// module id = 2360
// module chunks = 5